<div class="component pt-5">


  <app-customize-shirt *ngIf="step === 1" [shirtSelections]="selections.shirt" [colors]="colors"
    [validationResult]="triedNextOnStep1 ? lastValidation : null"
    (shirtSelectionsChange)="setData('shirt', $event.part, $event.value)" />
  <app-customize-short *ngIf="step === 2" [colors]="colors" [shortSelections]="selections.short"
    [validationResult]="triedNextOnStep2 ? lastValidation : null"
    (shortSelectionsChange)="setData('short', $event.part, $event.value)" />
  <app-customize-socks *ngIf="step === 3" [colors]="colors" [socksSelections]="selections.socks"
    [validationResult]="triedNextOnStep3 ? lastValidation : null"
    (socksSelectionsChange)="setData('socks', $event.part, $event.value)" />
  <br><br>
  <div class="text-center">
    <h2 class="main-title ">
      {{ step === 4 ? ('CUSTOMIZATION.UPLOAD_LOGO' | translate) : ('CUSTOMIZATION.OUTFIT_PREVIEW' | translate) }}
    </h2>

    <div class="svg-container position-relative">
      <div class="svg-logo">
        <div inlineSVG="assets/img/customize/out-fit.svg" *ngIf="selections.shirt.jersyType === 'raglan'" #svgOutFit>
        </div>
        <img [src]="selections.shirt.logoPath" class="main-logo" [ngClass]="{
            'basic-main-logo': selections.shirt.jersyType === 'basic'
          }" />
        <img [src]="selections.shirt.logoPath" class="short-logo" [ngClass]="{
            'basic-short-logo': selections.shirt.jersyType === 'basic'
          }" />
        <div inlineSVG="assets/img/customize/out-fit2.svg" *ngIf="selections.shirt.jersyType === 'basic'" class="basic"
          #svgOutFit></div>
      </div>
    </div>

    <app-choose-sizes *ngIf="step === 5" (sizesSelectionsChange)="setData('sizes', $event.part, $event.value)"
      (marterialSelectionsChange)="setData('materials', $event.part, $event.value)">
    </app-choose-sizes>


    <div class="controls-btns">
      <button id="downloadImageButton" class="btn btn-outline-light btn-sm customize-btn" *ngIf="step === 5"
        (click)="downloadColoredSvg()">
        {{ 'CUSTOMIZATION.DOWNLOAD_PNG' | translate }}
      </button>
      <button id="sendWhatsAppButton" class="btn btn-outline-light btn-sm customize-btn" *ngIf="step === 5"
        (click)="sendColoredSvgToWhatsApp()">
        {{ 'CUSTOMIZATION.SEND_WHATSAPP' | translate }}
      </button>
      <button id="sendEmailButton" class="btn btn-outline-light btn-sm customize-btn" (click)="sendColoredSvgToEmail()"
        *ngIf="step === 5">
        {{ 'CUSTOMIZATION.SEND_EMAIL' | translate }}
      </button>
      <div *ngIf="step === 4">
        <label for="img" class="btn btn-outline-light btn-sm customize-btn">
          {{ 'CUSTOMIZATION.UPLOAD_LOGO' | translate }}
          <input type="file" id="img" name="image" hidden (change)="uploudLogo($event)" />
        </label>
      </div>
      <button id="nextButton" class="btn btn-outline-light btn-sm customize-btn" *ngIf="step < 5" (click)="nextStep()"
        [disabled]="step === 1 && triedNextOnStep1 && lastValidation && !lastValidation.valid
                    || step === 2 && triedNextOnStep2 && lastValidation && !lastValidation.valid
                    || step === 3 && triedNextOnStep3 && lastValidation && !lastValidation.valid">
        {{ 'CUSTOMIZATION.NEXT' | translate }}
      </button>

      <button id="backButton" class="btn btn-outline-dark btn-sm reset-btn" *ngIf="step > 1" (click)="previousStep()">
        {{ 'CUSTOMIZATION.BACK' | translate }}
      </button>
      <button id="resetButton" class="btn btn-outline-dark btn-sm reset-btn" (click)="reset()">
        {{ 'CUSTOMIZATION.RESET' | translate }}
      </button>


      <div *ngIf="
      (step === 1 && triedNextOnStep1 && lastValidation && !lastValidation.valid) ||
      (step === 2 && triedNextOnStep2 && lastValidation && !lastValidation.valid) ||
      (step === 3 && triedNextOnStep3 && lastValidation && !lastValidation.valid)
    " class="text-danger small mt-2">
        <!-- If you have i18n keys, use them; otherwise fall back to plain text -->
        <ng-container *ngFor="let key of lastValidation.errorKeys">
          <!-- preferred i18n key (adjust namespace if you want) -->
          <!-- <div>{{ ('CUSTOMIZATION.VALIDATION.' + key) | translate }}</div> -->
        </ng-container>

        <!-- fallback (in case a translation is missing) -->
        <ng-container *ngIf="!lastValidation.errorKeys?.length && lastValidation.errors?.length">
          <div *ngFor="let msg of lastValidation.errors">{{ msg }}</div>
        </ng-container>
      </div>
    </div>
  </div>